// extracted by mini-css-extract-plugin
export default {"loaderRectangle":"UgIpzQ9ojbrs7XTJAjCh","rectangleOneAnim":"Br5vXSPZJZeNcGjVvqOf","rectangleTwoAnim":"NtG3I2bsvHEMQIZ2GfV6","rectangleThreeAnim":"baNUilaY0mWnWbtEjfYs"};